import { frontendURL } from '../../../../helper/URLHelper';
import Index from './Index.vue';
import Edit from './Edit.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/email-templates'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'email_templates_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: ':templateName',
          name: 'email_templates_edit',
          component: Edit,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
